import { render, staticRenderFns } from "./ListSupplier.vue?vue&type=template&id=4fcc3e0c"
import script from "./ListSupplier.vue?vue&type=script&lang=js"
export * from "./ListSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports